var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.102 9.596c.223-.259.419-.543.582-.846h2.318a2 2 0 0 0 2-2 1 1 0 0 0-1-1h-2.81A4.751 4.751 0 1 0 9.46 9H4.5A1.5 1.5 0 0 0 3 10.5v.75a7 7 0 0 0 7 7h.967l.056-.125A4.553 4.553 0 0 1 10.5 16c0-1.236.613-2.465 1.477-3.387a6.326 6.326 0 0 1 3.793-1.941 19.779 19.779 0 0 1 2.348-.177 4.021 4.021 0 0 0-1.016-.899Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.24 17.954c-.738 1.109-1.174 2.286-1.233 3.251a.75.75 0 0 0 1.497.091c.032-.514.242-1.21.646-1.95.592.62 1.521 1.158 2.85 1.158 1.304 0 2.28-.457 2.999-1.19.693-.706 1.105-1.626 1.397-2.488.148-.436.27-.876.382-1.286l.057-.212c.09-.334.173-.64.261-.925.107-.344.21-.617.32-.825.11-.21.203-.302.26-.34a.75.75 0 0 0-.212-1.348c-1.024-.288-2.762-.598-5.562-.227a5.326 5.326 0 0 0-3.195 1.634c-.74.79-1.207 1.786-1.207 2.703 0 .377.058.718.148 1.02.215-.322.459-.639.726-.944a9.896 9.896 0 0 1 5.005-3.061.5.5 0 0 1 .242.97 8.895 8.895 0 0 0-4.495 2.751c-.352.4-.647.812-.886 1.218Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIcons);
export default __webpack_public_path__ + "static/media/ic-icons.f3ad4d15a1480c36abaa83dfad12142c.svg";
export { ForwardRef as ReactComponent };